export { default as CourseDetailsEditorPage } from './CourseDetailsEditor';
export { default as CourseManagementPage } from './CourseManagement';
export { default as LessonEditor } from './LessonEditor';
export { default as MainTakeawaysEditor } from './MainTakeawaysEditor';
